module.exports = __webpack_public_path__ + "static/img/mint-ui.b8d6b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mint-ui.png
// module id = xO8W
// module chunks = 0